import { lazy } from 'react';

// ----------------------------------------------------------------------

const JobPage = lazy(() => import('../pages/Job.page'));
const InterviewsPage = lazy(() => import('../pages/Interviews.page'));
const ApplicantsPage = lazy(() => import('../pages/Applicants.page'));
const AddApplicantPage = lazy(() => import('../pages/AddApplicant.page'));
const ApplicantDetailsPage = lazy(() => import('../pages/ApplicantDetails.page'));
const CareerPathPage = lazy(() => import('../pages/CareerPath.page'));
// ----------------------------------------------------------------------

const CareerPathRoutes = [
    {
        path: '/career-path',

        children: [
            {
                element: <CareerPathPage />,
                layout: 'default',
                isAuthReq: true,
                index: true,
            },
            {
                path: 'job',
                element: <JobPage />,
                layout: 'default',
                isAuthReq: true,
            },

            {
                path: 'interviews',
                element: <InterviewsPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'applicants/add',
                element: <AddApplicantPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'applicants/:id',
                element: <ApplicantDetailsPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'applicants',
                element: <ApplicantsPage />,
                layout: 'default',
                isAuthReq: true,
            },
        ],
    },
];

export { CareerPathRoutes };
